"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { memo } from "react";
import Link from "next/link";
import { MovieItem } from "@/types/movies";
import Badge from "../badge/Badge";
import SeriesStack from "./SeriesStack";
import defaultItem from '../../../public/defaultposter.webp';
import { slugify } from "@/lib/slugify";
function formatDuration(str: string) {
  const [h, m] = str.split(":").map(Number);
  const parts = [];
  if (h) parts.push(`${h} ساعت`);
  if (m) parts.push(`${m} دقیقه`);
  return parts.join(" و ");
}
function SwiperItemComponent(t0) {
  const $ = _c(105);
  const {
    poster_url,
    title_fa,
    title_en,
    has_subtitles,
    has_dubbing,
    type,
    imdb_rate,
    release_date,
    duration,
    tags,
    unique_code,
    href
  } = t0;
  const mainImage = poster_url || defaultItem;
  let t1;
  if ($[0] !== release_date) {
    t1 = release_date ? new Date(release_date).getFullYear() : "";
    $[0] = release_date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const year = t1;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t21;
  let t22;
  let t23;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== duration || $[3] !== has_dubbing || $[4] !== has_subtitles || $[5] !== href || $[6] !== imdb_rate || $[7] !== mainImage || $[8] !== tags || $[9] !== title_en || $[10] !== title_fa || $[11] !== type || $[12] !== unique_code || $[13] !== year) {
    const country = tags?.filter(_temp)?.map(_temp2).slice(0, 1) ?? [];
    const genres = tags?.filter(_temp3)?.map(_temp4).slice(0, 3) ?? [];
    let t24;
    if ($[37] !== tags) {
      t24 = tags?.find(_temp5);
      $[37] = tags;
      $[38] = t24;
    } else {
      t24 = $[38];
    }
    const isExclusive = t24;
    const t25 = title_en || title_fa;
    let t26;
    if ($[39] !== t25) {
      t26 = slugify(t25);
      $[39] = t25;
      $[40] = t26;
    } else {
      t26 = $[40];
    }
    const fallbackSlug = t26;
    const fallbackSuffix = fallbackSlug ? `/${fallbackSlug}` : "";
    const linkUrl = href ? href : `${type === "series" ? "/s" : "/movie"}/${unique_code}${fallbackSuffix}`;
    T0 = Link;
    t22 = linkUrl;
    t23 = "block max-w-[155px] sm:max-w-[180px] md:max-w-[200px] lg:max-w-[240px] xl:max-w-[280px] 2xl:max-w-[320px] h-auto aspect-[220/320]";
    t20 = `relative w-full h-full group ${type === "series" ? "series-mode" : ""}`;
    if ($[41] !== mainImage || $[42] !== title_fa || $[43] !== type) {
      t21 = type === "series" && <SeriesStack src={mainImage} alt={title_fa || ""} sizes="(max-width: 640px) 155px, (max-width: 768px) 180px, 240px" />;
      $[41] = mainImage;
      $[42] = title_fa;
      $[43] = type;
      $[44] = t21;
    } else {
      t21 = $[44];
    }
    t19 = `w-full h-full rounded-[20px] p-[1px] bg-transparent ${type === "series" ? "relative z-10" : ""}`;
    t13 = "relative w-full h-full rounded-[19px] overflow-hidden";
    if ($[45] !== has_dubbing || $[46] !== has_subtitles || $[47] !== isExclusive?.name_en || $[48] !== type) {
      t14 = (has_subtitles || has_dubbing || type) && <Badge has_subtitles={has_subtitles} has_dubbing={has_dubbing} type={isExclusive?.name_en} />;
      $[45] = has_dubbing;
      $[46] = has_subtitles;
      $[47] = isExclusive?.name_en;
      $[48] = type;
      $[49] = t14;
    } else {
      t14 = $[49];
    }
    const t27 = title_fa || "";
    if ($[50] !== mainImage || $[51] !== t27) {
      t15 = <Image src={mainImage} alt={t27} fill={true} className="object-cover rounded-[20px]" sizes="(max-width: 640px) 155px, (max-width: 768px) 180px, (max-width: 1024px) 200px, (max-width: 1280px) 240px, 320px" />;
      $[50] = mainImage;
      $[51] = t27;
      $[52] = t15;
    } else {
      t15 = $[52];
    }
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div className="absolute inset-0 rounded-[20px] transition-opacity duration-300 sm:group-hover:opacity-0" style={{
        background: "linear-gradient(156.58deg, rgba(217,217,217,0) 17.61%, rgba(0,36,53,0.8) 91.39%, #002435 96.08%)"
      }} />;
      $[53] = t16;
    } else {
      t16 = $[53];
    }
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <div className="absolute inset-0 rounded-[20px] transition-opacity duration-300 opacity-0 sm:group-hover:opacity-100 hidden sm:block" style={{
        background: "linear-gradient(91.94deg, rgba(217,217,217,0) -144.34%, rgba(0,36,53,0.8) 66.76%, #002435 92.19%)"
      }} />;
      $[54] = t17;
    } else {
      t17 = $[54];
    }
    let t28;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <div className="w-[1px] bg-white" style={{
        height: "1rem"
      }} />;
      $[55] = t28;
    } else {
      t28 = $[55];
    }
    if ($[56] !== title_fa) {
      t18 = <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-3 md:p-4 z-30 transition-transform duration-300 sm:group-hover:translate-y-full"><div className="flex items-center gap-2">{t28}<h3 className="text-white font-bold text-xs sm:text-sm truncate">{title_fa}</h3></div></div>;
      $[56] = title_fa;
      $[57] = t18;
    } else {
      t18 = $[57];
    }
    t12 = "absolute inset-0 z-30 p-2 sm:p-3 md:p-4 hidden sm:flex flex-col justify-end translate-y-full transition-transform duration-500 ease-out sm:group-hover:translate-y-0";
    t10 = "flex gap-2 sm:gap-3";
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="w-[1px] bg-white shrink-0" />;
      $[58] = t11;
    } else {
      t11 = $[58];
    }
    t8 = "flex-1 space-y-1 sm:space-y-2 text-right";
    if ($[59] !== title_fa) {
      t9 = <h3 className="text-white font-bold text-xs sm:text-sm truncate">{title_fa}</h3>;
      $[59] = title_fa;
      $[60] = t9;
    } else {
      t9 = $[60];
    }
    t2 = "space-y-1";
    if ($[61] !== title_en) {
      t3 = title_en && <div className="text-white/70 text-[10px] sm:text-xs truncate">{title_en}</div>;
      $[61] = title_en;
      $[62] = t3;
    } else {
      t3 = $[62];
    }
    if ($[63] !== imdb_rate) {
      t4 = imdb_rate ? <div className="flex items-center justify-start gap-1"><span className="text-[10px] sm:text-xs font-extrabold text-imdb">IMDB</span><span className="text-[10px] sm:text-xs font-extrabold text-white">{imdb_rate}</span></div> : <></>;
      $[63] = imdb_rate;
      $[64] = t4;
    } else {
      t4 = $[64];
    }
    t5 = (country?.length > 0 || year) && <div className="text-white/70 text-[10px] sm:text-xs">{country?.map(_temp6)}{country?.length > 0 && year && <span> - </span>}{year && <span>{year}</span>}</div>;
    if ($[65] !== duration) {
      t6 = duration && <div className="text-white/70 text-[10px] sm:text-xs">{formatDuration(duration)}</div>;
      $[65] = duration;
      $[66] = t6;
    } else {
      t6 = $[66];
    }
    t7 = genres && genres.length > 0 && <div className="text-white/70 text-[10px] sm:text-xs">{genres.map((g, i) => <span key={i}>{g.name_fa}{i < genres.length - 1 && " - "}</span>)}</div>;
    $[2] = duration;
    $[3] = has_dubbing;
    $[4] = has_subtitles;
    $[5] = href;
    $[6] = imdb_rate;
    $[7] = mainImage;
    $[8] = tags;
    $[9] = title_en;
    $[10] = title_fa;
    $[11] = type;
    $[12] = unique_code;
    $[13] = year;
    $[14] = T0;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
    $[23] = t18;
    $[24] = t19;
    $[25] = t2;
    $[26] = t20;
    $[27] = t21;
    $[28] = t22;
    $[29] = t23;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    T0 = $[14];
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
    t14 = $[19];
    t15 = $[20];
    t16 = $[21];
    t17 = $[22];
    t18 = $[23];
    t19 = $[24];
    t2 = $[25];
    t20 = $[26];
    t21 = $[27];
    t22 = $[28];
    t23 = $[29];
    t3 = $[30];
    t4 = $[31];
    t5 = $[32];
    t6 = $[33];
    t7 = $[34];
    t8 = $[35];
    t9 = $[36];
  }
  let t24;
  if ($[67] !== t2 || $[68] !== t3 || $[69] !== t4 || $[70] !== t5 || $[71] !== t6 || $[72] !== t7) {
    t24 = <div className={t2}>{t3}{t4}{t5}{t6}{t7}</div>;
    $[67] = t2;
    $[68] = t3;
    $[69] = t4;
    $[70] = t5;
    $[71] = t6;
    $[72] = t7;
    $[73] = t24;
  } else {
    t24 = $[73];
  }
  let t25;
  if ($[74] !== t24 || $[75] !== t8 || $[76] !== t9) {
    t25 = <div className={t8}>{t9}{t24}</div>;
    $[74] = t24;
    $[75] = t8;
    $[76] = t9;
    $[77] = t25;
  } else {
    t25 = $[77];
  }
  let t26;
  if ($[78] !== t10 || $[79] !== t11 || $[80] !== t25) {
    t26 = <div className={t10}>{t11}{t25}</div>;
    $[78] = t10;
    $[79] = t11;
    $[80] = t25;
    $[81] = t26;
  } else {
    t26 = $[81];
  }
  let t27;
  if ($[82] !== t12 || $[83] !== t26) {
    t27 = <div className={t12}>{t26}</div>;
    $[82] = t12;
    $[83] = t26;
    $[84] = t27;
  } else {
    t27 = $[84];
  }
  let t28;
  if ($[85] !== t13 || $[86] !== t14 || $[87] !== t15 || $[88] !== t16 || $[89] !== t17 || $[90] !== t18 || $[91] !== t27) {
    t28 = <div className={t13}>{t14}{t15}{t16}{t17}{t18}{t27}</div>;
    $[85] = t13;
    $[86] = t14;
    $[87] = t15;
    $[88] = t16;
    $[89] = t17;
    $[90] = t18;
    $[91] = t27;
    $[92] = t28;
  } else {
    t28 = $[92];
  }
  let t29;
  if ($[93] !== t19 || $[94] !== t28) {
    t29 = <div className={t19}>{t28}</div>;
    $[93] = t19;
    $[94] = t28;
    $[95] = t29;
  } else {
    t29 = $[95];
  }
  let t30;
  if ($[96] !== t20 || $[97] !== t21 || $[98] !== t29) {
    t30 = <div className={t20}>{t21}{t29}</div>;
    $[96] = t20;
    $[97] = t21;
    $[98] = t29;
    $[99] = t30;
  } else {
    t30 = $[99];
  }
  let t31;
  if ($[100] !== T0 || $[101] !== t22 || $[102] !== t23 || $[103] !== t30) {
    t31 = <T0 href={t22} className={t23}>{t30}</T0>;
    $[100] = T0;
    $[101] = t22;
    $[102] = t23;
    $[103] = t30;
    $[104] = t31;
  } else {
    t31 = $[104];
  }
  return t31;
}
function _temp6(c, idx) {
  return <span key={idx}>{c.name_fa}</span>;
}
function _temp5(item_3) {
  return item_3?.name_en === "exclusive";
}
function _temp4(item_2) {
  return item_2;
}
function _temp3(item_1) {
  return item_1?.type === "\u0698\u0627\u0646\u0631";
}
function _temp2(item_0) {
  return item_0;
}
function _temp(item) {
  return item?.type === "\u06A9\u0634\u0648\u0631";
}
export const SwiperItem = memo(SwiperItemComponent);